module.exports = __webpack_public_path__ + "media/application/images/2018/header-lock-green-06331eb3e9870cb45ef7d165b201d6a1.svg";